__turbopack_context__.v({
  "appearAnim": "LSgTkG_appearAnim",
  "root": "LSgTkG_root",
});
